import React from "react";
import "./TableStatus.scss";
import {
  SessionStatusConstants,
  SessionStatusTypes,
} from "../../utils/constants/session-status-constants";

interface StatusProps {
  status: SessionStatusTypes;
}

const TableStatus: React.FC<StatusProps> = ({ status }) => {
  return (
    <span
      className={`status-progress-tag ${
        "statusUpdate-" + status?.toLowerCase()
      }`}
    >
      {SessionStatusConstants[status]?.badgeText}
    </span>
  );
};

export default TableStatus;
